import React, { useEffect } from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { LinearLoading, CustomAutocomplete, CustomLoading } from '../../../../common'

export const FormAssignment = ({ useFetchInit }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { modalOpeningMode, loadingSubmitForm } = globalStates

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen
    
    const { fetchCategories, fetchAllCashRegisters, fetchUsers } = FetchData
    const { dataCategories, loadingFetchCategories } = fetchCategories
    const { dataCashRegisters, loadingFetchCashRegisters } = fetchAllCashRegisters
    const { dataUsers, loadingFetchUsers } = fetchUsers

    const {
        onSubmitForm,
        handleClickHideForm
    } = Actions

    useEffect(() => {
        
        fetchAllCashRegisters.setParamsToSearch({
            idcategoria: formState.idcategoria,
            currency_type: formState.currency_type
        })
        fetchAllCashRegisters.executeFetch()

    }, [formState.idcategoria, formState.currency_type])

    return (
        <Card style={{zIndex:'1'}}>
            <CardContent>
                <div className='h4 mt-1 mb-1'>
                    {formState.idmovimiento > 0
                        ? 'Informacion de Registro'
                        : 'Crear Registro'}
                </div>
                <div className="border-bottom border-dark"></div>
                {/* {loadingFetchSpecificTransactionCashier && ( <LinearLoading /> )} */}

                <div className="pt-3"></div>
                <p className='text-danger'>* campos obligatorios</p>
                <div className="pt-2"></div>

                <form onSubmit={onSubmitForm}>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="idcategoria">* Categoría</label>
                                {(loadingFetchCategories)&&(<LinearLoading/>)}
                                <CustomAutocomplete 
                                    customId="idcategoria"
                                    customName="idcategoria"
                                    customValue={formState.idcategoria}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcategoria', value: value.value }})}
                                    customPlaceholder='Seleccionar opción'
                                    customOptions={
                                        dataCategories.map(({ idcategoria, nombre }) => ({
                                            value: idcategoria,
                                            name: nombre
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={(modalOpeningMode==='READONLY')}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="currency_type">* Tipo</label>
                                <TextField
                                    id="currency_type"
                                    name="currency_type"
                                    value={formState.currency_type}
                                    onChange={onInputChange}
                                    select
                                    size="small"
                                    variant="outlined"
                                    hiddenLabel
                                    InputProps={{ 
                                        readOnly: false
                                    }}
                                >
                                    <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                    <MenuItem value='DOLAR'>DOLAR</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="idcaja">* Caja</label>
                                {(loadingFetchCashRegisters)&&(<LinearLoading/>)}
                                <CustomAutocomplete 
                                    customId="idcaja"
                                    customName="idcaja"
                                    customValue={formState.idcaja}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja', value: value.value }})}
                                    customPlaceholder='Seleccionar opción'
                                    customOptions={
                                        dataCashRegisters.map(({ idcaja, descripcion_corta, currency_type }) => ({
                                            value: idcaja,
                                            name: `${descripcion_corta} - ${currency_type}`
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={(modalOpeningMode==='READONLY')}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="idusuario">* Usuario</label>
                                {(loadingFetchUsers)&&(<LinearLoading/>)}
                                <CustomAutocomplete 
                                    customId="idusuario"
                                    customName="idusuario"
                                    customValue={formState.idusuario}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idusuario', value: value.value }})}
                                    customPlaceholder='Seleccionar una opción'
                                    customOptions={
                                        dataUsers.map(({ idusuario, nombre_usuario, nombre, email }) => ({
                                            value: idusuario,
                                            name: `${nombre} - ${nombre_usuario} - ${email}`
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={(modalOpeningMode==='READONLY')}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-4"></div>
                    {(loadingSubmitForm)&&(<CustomLoading/>)}
                    <Grid container>
                        <Grid item>
                            <div className='update ml-auto mr-auto'>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type='submit'
                                    disabled={(modalOpeningMode==='READONLY') || loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                    type='button'
                                    variant="contained"
                                    onClick={handleClickHideForm}
                                    disabled={loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}
